import { create } from 'zustand';
import { persist, subscribeWithSelector } from 'zustand/middleware';

import { type DownloadSlice, downloadSlice } from './downloadSlice';
import { type MainSlice, mainSlice } from './mainSlice';
import { type SurveySlice, surveySlice } from './surveySlice';
import { type UserSlice, userSlice } from './userSlice';

export type StoreType = MainSlice & UserSlice & SurveySlice & DownloadSlice;

export const useMainStore = create<StoreType>()(
   subscribeWithSelector(
      persist(
         (...a) => ({
            ...mainSlice(...a),
            ...userSlice(...a),
            ...surveySlice(...a),
            ...downloadSlice(...a),
         }),
         {
            name: 'questionnaire-store',
            partialize: (state) => ({
               currentUser: state.currentUser,
               downloads: state.downloads,
            }),
         },
      ),
   ),
);
